import React from 'react';
import ReactDOM from 'react-dom';
import './assets/sass/app.scss';
import App from './views/app/App';

ReactDOM.render(<App />, document.getElementById('root'));
